import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Detalhamento} from './detalhamento';
import {environment} from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DetalhamentoService {

    constructor(private http: HttpClient) {
    }

    private baseUrl = environment.urlApi + '/api/produtos/';

    public getDetalhamento(id: string): Observable<Detalhamento> {
        return this.http.get<Detalhamento>(this.baseUrl + id);
    }

}
